import React from 'react';
import PropTypes from 'prop-types';
import styles from './Heading.module.scss';

const propTypes = {
  title: PropTypes.string.isRequired,
};

// TODO: make compatible with series detail headings with drop downs
const Heading = ({ title = '' }) => <h2 className={styles.h2}>{title}</h2>;

Heading.propTypes = propTypes;
export default Heading;
